import Vuex from 'vuex'
import Vue from 'vue'
import userInfo from './userInfo'
import menu from './menu'
import tabs from './tabs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    systemName: 'Pinjun Web Framework'
  },
  modules: {
    userInfo,
    menu,
    tabs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js